import { Page } from "@/models/page-models/Page";

export const ViewInvoice: Page = {
  "path": "view-invoice",
  "name": "Invoices Dashboard",
  "props": {
    "data": {
      "title": "Invoices Dashboard",
      "printable": "FALSE",
      "url": "view-invoice",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData",
                  "label": "Orders",
                  "disabled": "FALSE",
                  "items": "fetchedData.allInvoices.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Invoice #",
                      "width": 79
                    },
                    {
                      "value": "__item.customer.name",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "createdAt",
                      "text": "Invoice Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "__item.total",
                      "text": "Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.total}})",
                      "width": 110
                    },
                    {
                      "value": "__item.status",
                      "text": "Status"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions",
                      "actions": [
                        {
                          "label": "View",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "redirectToInvoice"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "tableType": "static",
                  "showActions": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getAllInvoices",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
      }
    ],
    "functions": [
      {
        "name": "getAllInvoices",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice/all-invoices?page=1&limit=50",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.allInvoices"
      },
      {
        "name": "redirectToInvoice",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/invoice/{{__item._id}}"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false,
  "routerPriority": 75
}